import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useHaptic } from '@/hooks/useHaptic';

interface NumberCardProps {
  number: number;
  onSelect: () => void;
  disabled?: boolean;
}

export default function NumberCard({ number, onSelect, disabled }: NumberCardProps) {
  const { vibrate } = useHaptic();

  const handleSelect = () => {
    vibrate('medium');
    onSelect();
  };

  return (
    <motion.div
      whileHover={!disabled ? { scale: 1.05 } : {}}
      whileTap={!disabled ? { scale: 0.95 } : {}}
      className="w-full"
    >
      <Button
        onClick={handleSelect}
        disabled={disabled}
        className="
          w-full h-64 md:h-80
          min-h-[176px]
          min-w-[176px]
          touch-manipulation
          glass-card
          border-4 border-border/30
          hover:border-primary/60
          active:border-primary/80
          disabled:opacity-50
          disabled:cursor-not-allowed
          flex items-center justify-center
          text-7xl sm:text-8xl md:text-9xl font-black
          text-shadow
          transition-all duration-200
          hover:glow-green
          active:glow-green
          pointer-events-auto
          cursor-pointer
          select-none
        "
        variant="secondary"
      >
        {number}
      </Button>
    </motion.div>
  );
}
